import _ from 'underscore';
import { useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';

export default function useScope() {
  const scope = _.chain(useContext(ScopeContext)).result('scope').result('values').value();
  return scope;
}
